import { render, staticRenderFns } from "./Accounts.vue?vue&type=template&id=d2b6128e&scoped=true"
import script from "./Accounts.vue?vue&type=script&lang=ts"
export * from "./Accounts.vue?vue&type=script&lang=ts"
import style0 from "./Accounts.vue?vue&type=style&index=0&id=d2b6128e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b6128e",
  null
  
)

export default component.exports